// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Geist-Variable.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Geist-Variable-Italic.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Geist — platform typeface. Variable woff2, weight 100-900, upright + italic.
   OFL licence text sits next to the files in ./fonts/OFL.txt. */
@font-face {
	font-family: 'Geist';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2-variations');
	font-weight: 100 900;
	font-style: normal;
	font-display: swap;
}

@font-face {
	font-family: 'Geist';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2-variations');
	font-weight: 100 900;
	font-style: italic;
	font-display: swap;
}

/* ponytail: ~50 call sites (and @plecto/ui's theme.font) still name
   "Red Hat Display" literally. Rather than edit each one, the old family name
   is re-pointed at the Geist files here. Ceiling: any future rule that really
   wants Red Hat Display cannot get it. Upgrade path — swap the literals for
   \`Geist\` / theme.font and delete these two blocks. */
@font-face {
	font-family: 'Red Hat Display';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2-variations');
	font-weight: 100 900;
	font-style: normal;
	font-display: swap;
}

@font-face {
	font-family: 'Red Hat Display';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2-variations');
	font-weight: 100 900;
	font-style: italic;
	font-display: swap;
}

/* The brand's alternates: ss02 is the simplified single-storey \`a\`, plus ss03
   and ss04. font-feature-settings inherits, so stating it on the root covers the
   tree without an \`*\` selector. */
:root {
	font-family: 'Geist', sans-serif;
	font-feature-settings: 'ss02' on, 'ss03' on, 'ss04' on;
}

body {
	font-family: 'Geist', sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/shared/styles/fonts.css"],"names":[],"mappings":"AAAA;gEACgE;AAChE;CACC,oBAAoB;CACpB,uEAAmE;CACnE,oBAAoB;CACpB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,uEAA0E;CAC1E,oBAAoB;CACpB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;;;;sDAIsD;AACtD;CACC,8BAA8B;CAC9B,uEAAmE;CACnE,oBAAoB;CACpB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;CAC9B,uEAA0E;CAC1E,oBAAoB;CACpB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;;kCAEkC;AAClC;CACC,gCAAgC;CAChC,sDAAsD;AACvD;;AAEA;CACC,gCAAgC;AACjC","sourcesContent":["/* Geist — platform typeface. Variable woff2, weight 100-900, upright + italic.\n   OFL licence text sits next to the files in ./fonts/OFL.txt. */\n@font-face {\n\tfont-family: 'Geist';\n\tsrc: url('./fonts/Geist-Variable.woff2') format('woff2-variations');\n\tfont-weight: 100 900;\n\tfont-style: normal;\n\tfont-display: swap;\n}\n\n@font-face {\n\tfont-family: 'Geist';\n\tsrc: url('./fonts/Geist-Variable-Italic.woff2') format('woff2-variations');\n\tfont-weight: 100 900;\n\tfont-style: italic;\n\tfont-display: swap;\n}\n\n/* ponytail: ~50 call sites (and @plecto/ui's theme.font) still name\n   \"Red Hat Display\" literally. Rather than edit each one, the old family name\n   is re-pointed at the Geist files here. Ceiling: any future rule that really\n   wants Red Hat Display cannot get it. Upgrade path — swap the literals for\n   `Geist` / theme.font and delete these two blocks. */\n@font-face {\n\tfont-family: 'Red Hat Display';\n\tsrc: url('./fonts/Geist-Variable.woff2') format('woff2-variations');\n\tfont-weight: 100 900;\n\tfont-style: normal;\n\tfont-display: swap;\n}\n\n@font-face {\n\tfont-family: 'Red Hat Display';\n\tsrc: url('./fonts/Geist-Variable-Italic.woff2') format('woff2-variations');\n\tfont-weight: 100 900;\n\tfont-style: italic;\n\tfont-display: swap;\n}\n\n/* The brand's alternates: ss02 is the simplified single-storey `a`, plus ss03\n   and ss04. font-feature-settings inherits, so stating it on the root covers the\n   tree without an `*` selector. */\n:root {\n\tfont-family: 'Geist', sans-serif;\n\tfont-feature-settings: 'ss02' on, 'ss03' on, 'ss04' on;\n}\n\nbody {\n\tfont-family: 'Geist', sans-serif;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
